var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 82,
    fill: "url(#pattern0_1013_94)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1013_94",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1013_94",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1013_94",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAELklEQVR4nO2cS4hURxRAb/yhIcYvigou3GQjqFmIIpKNGJ248rPIJvgBP/hZZCNBJX5wMooZdTMhiZqgQoSAa8lCURMGFcSl4g8VMRmdUSajo47mhII72Au1u6tfv7r1ug40DN093fce6PeqblVdkUQikUgkEolEIpFIlAcYBMwAlgM7gKPAn8AN4B7QBfTpo0ufc6+d1/fu0P91nzGogq9sDICBwGfAHpX1lOxwn3UOaAHmuu+SRgIYACwAfgEekh8dwBHgcxeDFBVgPLAZuEl43CVnOzBOigIwVn++z7DHC+BHYILECjAc+A7owT7/As3ARxITwBfAHeLjPrBYrAOMBn4nfk4Ao8QiOna1cKPLCveLnCmWAFYCvRSPXmCFWECHbEWnJaTgD4C9NA4HXc4hRDeS5H6a85a8gTC0A636cH+HYG1ekhcBr3JO7jGw8C2xNAFPco7F5d5Ub8mTgEfkz8Iyk6O86ajbtF2rbqcDJNVeQWwXAsT1R12qgMAmwrCvgti+DxTbunpMrTsNi24NFNvDTKfqOoYMRbvRS0c/rVneAF8SlqYyo6DQNe2JWYjeTXieuNHFOyTnPbx7G7tqlTws53W9clzQ6/F+4CJ2+AcYWovoL0NnEBHLahHtCuCJyjjmK3mwTn0TldHptWkHmFPhFyTeMDumCl3MVD9TBH4KHXWE/OAj+q/QUUfIeR/R1zGEvDtOS1zzEe1qrmaQOET/7SP6OYaQOEQ/9xHtiiVmkDhE9/qIDrFkFbvoBz6ib2MIiUP0VR/R7qiDGSQO0V7Du58xhMQhus1H9NcYQuIQ7TUFn4UhJA7Rs32PprmzfCYQ+6L9yqSaxEmMIPZFH/WSrEkswQhiX/TSWkQPsVLzENuia1uc1UT2YQCxLXpnTZI1kQkWDmOKXdEvMttZGnhLmHXRZfcGViN6TOiNNGJTtLt/jcxMtCa0KmRGYlP0mkwll5zCOhMqI7En+lTdTmlpK4gHIbISW6Lrd7SiJLH5wGsalz7X2KWukktkr6VxWZ+L5BLZu2g8duYqueTmWKRuBuVoCXJEWWUfpvj85xoLBBFcInobxabX9dELKtniclfGuC1x08UCwBaKyXFghFjB2kp5BtzKbYxcDcAVikG39jX9UKyh03E3S4qZHu2LOkasAmwl7hvdZtdlUiJoP5xFA8Gn5LuudwiYF2ziEeAgUQ+wUfeOfAp8o71A3LUyyzaYZ/SI9ZzoOuwCk2s8f3gamPKe5iuf6Ild1w33V33/NW1n2aWtdvobdd/V187qe78FvgKmRd0vWrcfuA7lvjXc1dH8bEOhRSTX3t3nOrzH1ATAuOS2KgV3a8VrXOj4owE4UIXgy7ow8HHouKOjzGjAlREvad1jauhYo0aHSM+0N767Gf6mJVK3fpiuvYlEIpFIJBKJRCIhEfM/e8RFIOC8oEAAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.37fa3b0b5ef99093aaf35ad47bbfa6b7.svg";
export { ForwardRef as ReactComponent };